import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import NewRequest from './components/NewRequest';
import RequestDetails from './components/RequestDetails';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  const [user, setUser] = useState(null);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route 
            path="/" 
            element={user ? <Navigate to="/dashboard" /> : <Login setUser={setUser} />} 
          />
          <Route 
            path="/dashboard" 
            element={user ? <Dashboard user={user} setUser={setUser} /> : <Navigate to="/" />} 
          />
          <Route 
            path="/new-request" 
            element={user ? <NewRequest user={user} /> : <Navigate to="/" />} 
          />
          <Route 
            path="/request/:requestId" 
            element={user ? <RequestDetails user={user} /> : <Navigate to="/" />} 
          />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;